import React from 'react';
import PropTypes from 'prop-types';

import currencyFormat from 'components/Widgets/currencyFormat';

export default function PolicyPlan({ plan }) {
  const sessionsTitle = (sessions) => (sessions === '0' ? 'TA' : sessions);

  const total = plan.attributes.payment_mode === 'monthly'
    ? plan.attributes.monthly_total
    : plan.attributes.annual_total;

  return (
    <tr>
      <th scope="row" className="fw-light text-end">
        {plan.attributes.name}
      </th>

      <td className="fw-semibold">
        {sessionsTitle(plan.attributes.sessions)}
      </td>

      <td className="fw-semibold">
        {plan.attributes.employees_covered_title}
      </td>

      <td className="fw-semibold">
        {currencyFormat(plan.attributes.price_employee_month, { currency: plan.attributes.currency.title })}
      </td>

      <td className="fw-semibold">
        {plan.attributes.is_pay_per_used
          ? currencyFormat(plan.attributes.price_session, { currency: plan.attributes.currency.title })
          : 'N/A'}
      </td>

      <td>
        {plan.attributes.payment_method || 'Free'}
      </td>

      <td className="bg-primary-100 fw-semibold">
        {currencyFormat(total, { currency: plan.attributes.currency.title })}
      </td>
    </tr>
  );
}

PolicyPlan.propTypes = {
  plan: PropTypes.object.isRequired,
};
